import { FC, useCallback } from "react";
import translate from "src/lib/translate";
import { AppQueryPopupsController } from "src/ui/components/AppQueryPopups/AppQueryPopupsBloc";
import { ChatUploadLabResults } from "src/ui/components/ChatUploadLabResults/ChatUploadLabResults";
import InDialog from "src/ui/components/InDialog/InDialog";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";

const ChatUploadLabResultDialog: FC<{ returnUrl: string }> = ({
  returnUrl
}) => {
  const navigate = useGoToOrBack();

  const closeDialog = useCallback(() => {
    AppQueryPopupsController.closePopup();
    navigate(returnUrl, {
      multiBack: true,
      replace: true
    });
  }, [navigate, returnUrl]);

  return (
    <InDialog
      popup
      title={translate("chat.labReport.title")}
      returnUrl={returnUrl}
      onClose={closeDialog}
    >
      <nine-spacer s="md" />
      <ChatUploadLabResults closeDialog={closeDialog} />
    </InDialog>
  );
};

export default ChatUploadLabResultDialog;
